import {
  aNetworkBlock,
  aNetworkBlockPage,
  mockNetworkBlockEditorOperationQuery,
  mockNetworkBlocksOperationQuery,
  NetworkBlock,
} from '__generated__';

export const getMockNetworkBlockEditorOperationQuery_edit = (
  networkBlock: Partial<NetworkBlock>
) => {
  return mockNetworkBlockEditorOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        networkBlock: aNetworkBlock({ id: '0', ...networkBlock }),
      })
    );
  });
};

export const getMockNetworkBlocksOperationQuery_create = (
  networkBlocks: Partial<NetworkBlock>[]
) => {
  const existingNetworkBlocks = aNetworkBlockPage().objects;
  const newNetworkBlocks = networkBlocks.map((networkBlock, i) =>
    aNetworkBlock({ id: `${i}`, ...networkBlock })
  );

  return mockNetworkBlocksOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        networkBlocks: aNetworkBlockPage({
          objects: [...existingNetworkBlocks, ...newNetworkBlocks],
        }),
      })
    );
  });
};

export const handlers = [
  mockNetworkBlocksOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        networkBlocks: aNetworkBlockPage(),
      })
    );
  }),
  mockNetworkBlockEditorOperationQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        networkBlock: aNetworkBlock(),
      })
    );
  }),
];
